import React, { useEffect, useMemo } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const StatementOnEmployeesCount = () => {
  const { t } = useLocalize()
  const { data, setData } = useRaportForm()

  const years = useMemo(() => {
    const currentYear = new Date().getFullYear()
    return [currentYear, currentYear - 1, currentYear - 2]
  }, [])

  useEffect(() => {
    setData({
      selectedYear: years[1],
      leaveEmpty: false,
      averageBasedOnContracts: false,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
    })
  }, [setData, years])

  const options = years.map((year) => ({
    value: year.toString(),
    label: year.toString(),
  }))

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <FieldsetSelect
            label={t('printout.statement-year')}
            placeholder={t('common.select')}
            value={
              data?.selectedYear !== undefined
                ? data.selectedYear.toString()
                : years[1].toString()
            }
            name="selectedYear"
            onChange={(e) => {
              setData({
                ...data,
                selectedYear: Number(e.target.value),
              })
            }}
            searchEnabled={false}
            options={options}
          />

          <CheckboxWithLabelField
            field="averageBasedOnContracts"
            data={data}
            setData={setData}
            label={t('printout.average-based-on-contracts')}
          />

          <CheckboxWithLabelField
            field="leaveEmpty"
            data={data}
            setData={setData}
            label={t('printout.leave-empty-values')}
          />
        </div>
      </div>
    </div>
  )
}

export default StatementOnEmployeesCount
